export default "__VITE_ASSET__Bd$73sX0__"